import { render, staticRenderFns } from "./ContentLoadingTwoGrid.vue?vue&type=template&id=5388c63a"
import script from "./ContentLoadingTwoGrid.vue?vue&type=script&lang=js"
export * from "./ContentLoadingTwoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports